module.exports = __webpack_public_path__ + "img/p7s.248650cf.svg";